import React from 'react';
import {makeStyles} from '@mui/styles';

import {SharedUsersTable} from './components';
import PageHeader from "../../../components/PageHeader/PageHeader";

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  }
}));

const SharedUserList = (props) => {
  const {memberGuid, companyId, memberName, documentId, documentName} = props.location.state;

  let memberNamePossessive = memberName ? memberName + (memberName.toLowerCase().endsWith('s') ? "'" : "'s") : "";
  let userForDocument = documentId && documentName;

  let documentNameText = (userForDocument === undefined) ? "" : " for " + documentName;

  let title = memberNamePossessive + " Virtual Data Room Users" + documentNameText;

  const classes = useStyles();
  return (
    <div>
      {memberGuid &&
      <div className={classes.root}>
        <div className={classes.content}>
          <PageHeader title={title} subTitle={"List all Virtual Data Room Users for Member"}/>
          <SharedUsersTable
            subtitle={'Available Multimedia shared with '}
            memberGuid={memberGuid}
            memberName={memberName}
            companyId={companyId}
            isSharedUser={false}
            documentId={documentId}
          />
        </div>
      </div>
      }
    </div>
  )
}

export default SharedUserList;
